const initialState = {
    statusMap: [],
    statusOptions: [],
    counts: {}
};

function ticketingReducer(state = initialState, action = {}) {
    switch (action.type) {
        case 'TICKET_STATUS_OPTIONS_SUCCESS':
            return {
                ...state,
                statusOptions: action.data.statusOptions,
                statusMap: action.data.statusMap,
                severityOptions: action.data.severityOptions,
                severityMap: action.data.severityMap,
                enterpriseOptions: action.data.enterpriseOptions,
                enterpriseMap: action.data.enterpriseMap
            };

        case 'GET_TICKETS_COUNTS_SUCCESS':
            return {
                ...state,
                counts: action.counts
            };
        default:
            return state;
    }
}

export default ticketingReducer;
